import apiConfig from '../config/api'
import { apiRequestorHelper } from '../helpers'

export default {
  create: (user) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/user/saveUser',
      method: 'post',
      body: user
    })
  },

  read: () => {
    return apiRequestorHelper({
      url: apiConfig.url + '/user/usersByClient',
      method: 'post'
    })
  },

  update: (user) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/user/saveUser',
      method: 'post',
      body: user
    })
  },

  delete: (id) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/user/deleteUser',
      method: 'post',
      body: { id }
    })
  },
  getParametroByKey: (key) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/user/getParametroByKey',
      method: 'post',
      body: { key }
    })
  },
}
